import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { hasAccessToSection, getDefaultPath } from '../../../helpers/roles';

const ProtectedRoute = ({ 
    component: Component, 
    section, 
    userRole, 
    userLoaded,
    ...rest 
}) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                if (!userLoaded) {
                    return null;
                }

                if (!hasAccessToSection(userRole, section)) {
                    return <Redirect to={getDefaultPath(userRole)} />;
                }

                return <Component {...props} />;
            }}
        />
    );
};

function mapStateToProps(state) {
    return {
        userRole: state.user.current_user.role,
        userLoaded: state.user.current_user.loaded,
    };
}

export default connect(mapStateToProps)(ProtectedRoute);

